import React from 'react';
import PropTypes from 'prop-types';
import { Input, Typography } from 'antd';

function FormInput({ name, type, className, value, onChange, label, hint, error, placeholder, disabled }) {
  const InputComponent = type === 'password' ? Input.Password : Input;

  return (
    <div className={className} style={{ marginBottom: 0, textAlign: 'left' }}>
      {label && <Typography.Text style={{ display: 'block', marginBottom: 4 }}>{label}</Typography.Text>}
      <InputComponent
        type={type === 'password' ? undefined : type}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
      />
      {hint && (
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {hint}
        </Typography.Text>
      )}
      {error && (
        <Typography.Text type="danger" style={{ fontSize: 12 }}>
          {error}
        </Typography.Text>
      )}
    </div>
  );
}

FormInput.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  hint: PropTypes.string,
  label: PropTypes.any,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.bool,
};

FormInput.defaultProps = {
  error: '',
  hint: '',
  label: null,
  type: 'text',
  placeholder: '',
};

export default FormInput;
